import { usePwaContext } from '../contexts/PwaContext';

const usePwa = () => usePwaContext();

export default usePwa;


